import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Book, BookKind, BookStatus } from "../../../model/book/Book";
import { selectLogin } from "../../../store/user/selector";
import {
    ContinueButton,
    LoginButton,
    OpenReportButton,
    RestartButton,
    ReviewButton,
    StartButton,
} from "./GridButton";

export function GridButtonGroup(props: { book: Book }) {
    const { book } = props;
    const login = useSelector(selectLogin);
    return <>{login ? <LoginButtonGroup book={book} /> : <NotLoginButtonGroup />}</>;
}

function LoginButtonGroup(props: { book: Book }) {
    const { book } = props;
    return (
        <>
            {book.template.kind === BookKind.Report ? (
                <ReportButtonGroup book={book} />
            ) : (
                <BookButtonGroup book={book} />
            )}
        </>
    );
}

function ReportButtonGroup(props: { book: Book }) {
    return <OpenReportButton book={props.book} />;
}

function BookButtonGroup(props: { book: Book }) {
    const { book } = props;
    const canRestart =
        book.template.kind === BookKind.Exercise ||
        book.template.kind === BookKind.ByType ||
        book.template.kind === BookKind.Hard ||
        book.template.kind === BookKind.Word;
    return (
        <Box>
            {book.status === BookStatus.NotOpen && <StartButton book={book} />}
            {book.status === BookStatus.Start && <ContinueButton book={book} />}
            {book.status === BookStatus.Finish && (
                <>
                    <ReviewButton book={book} />
                    {canRestart && <RestartButton book={book} />}
                </>
            )}
        </Box>
    );
}

function NotLoginButtonGroup() {
    return <LoginButton />;
}
